module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"back_to":"назад на {0}"},"en":{"back_to":"back to {0}"}}')
  delete Component.options._Ctor
}
